import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles, Box, Grid, Typography, Button, Link, TextField } from '@material-ui/core';
import { ArrowBackIcon } from 'components/icons';
import { GeometryFileImport } from 'components';
import { useTranslation } from 'react-i18next';
import { useProperties, useFields } from 'hooks';

const useStyles = makeStyles((theme) => ({
  backIcon: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  intro: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  button: {
    width: '100%',
    fontWeight: 300,
    fontSize: '20px',
    lineHeight: '24px',
    textTransform: 'unset',
  },

  formGroupGrid: {
    width: '100%',
    flexGrow: 1,
  },
}));

const FieldSideBarUpload = ({ field, errors, onSave, onCancel, setValues, onPrev }) => {
  // eslint-disable-line
  const classes = useStyles();
  const { t } = useTranslation();
  const { geometryLoad, setGeometryLoad } = useFields();
  const { selectedProperty } = useProperties();

  const handleOnSave = () => {
    setGeometryLoad(false);
    onSave();
  };

  const handleFieldChange = (event, name, value) => {
    if (event.persist) {
      setValues({ ...field, [name]: value });
    }
  };

  if (selectedProperty === undefined) {
    onPrev();
  }

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box>
        <Link onClick={onPrev} className={classes.backIcon}>
          <ArrowBackIcon size="small" />
          <Typography style={{ paddingLeft: 8 }}>{t('how_add_fields')}</Typography>
        </Link>
      </Box>
      <Box pb={2}>
        <Typography variant="h4" className={classes.intro}>
          {t('upload_fields_title')}
        </Typography>
      </Box>
      <Box pb={2}>
        <div className={classes.formGroupGrid}>
          <TextField
            fullWidth
            label={t('field_name')}
            name="name"
            size="small"
            autoComplete="name"
            onChange={(event) => handleFieldChange(event, 'name', event.target.value)}
            value={field?.name}
            placeholder={t('field_name')}
            helperText={errors && errors.name}
            error={!!(errors && errors.name)}
            inputProps={{
              maxLength: 24,
            }}
            required
          />
        </div>
      </Box>
      <Box pb={2}>
        <Typography component="div">{t('place_points')}</Typography>
      </Box>
      <Box flexGrow={1}>
        <Grid container spacing={2}>
          <Grid item>
            <GeometryFileImport
              setGeometry={(geometry) => {
                setValues({ ...field, geometry });
              }}
            />
          </Grid>
          <Grid item>
            <Button variant="contained" disableElevation key="cancel" onClick={onCancel}>
              {t('cancel')}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Button
          disabled={!(field?.name && geometryLoad)}
          color="primary"
          variant="contained"
          className={classes.button}
          onClick={handleOnSave}
        >
          {t('save')}
        </Button>
      </Box>
    </Box>
  );
};

FieldSideBarUpload.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  errors: PropTypes.object,
  setValues: PropTypes.func.isRequired,
};

FieldSideBarUpload.defaultProps = {
  errors: {},
};

export default FieldSideBarUpload;
